export function formatLocalized(number: number, forcedDecimalPlaces?: number): string {
	const options: Intl.NumberFormatOptions = { useGrouping: true }
	if (forcedDecimalPlaces !== undefined) {
		options.minimumFractionDigits = forcedDecimalPlaces
		options.maximumFractionDigits = forcedDecimalPlaces
	}
	return number.toLocaleString('de-DE', options)
}

export function appendUnit(formatted: string, unit: string): string {
	return unit ? formatted.replace(/([0-9,.]+)$/g, '$1 ' + unit) : formatted
}
